import axios from "axios";
import BasicChart from "./BasicChart";
import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from "react";

function ChartScreenTime({ campaign_id }) {
    const [screenTimeData, setScreenTimeData] = useState({ ox: [], oy: [] })

    const [selectedTimeWindowOption, setSelectedTimeWindowOption] = useState(
        { name: 'Hourly', code: 'dh' }
    );
    const timeWindowOptions = [
        { name: 'Hourly', code: 'dh' },
        { name: 'Daily', code: 'dd' },
        { name: 'Monthly', code: 'dm' },
        { name: 'Quarterly', code: 'dq' },
        { name: 'Yearly', code: 'dy' }
    ];

    function getScreenTime() {
        const params = new URLSearchParams([
            ['campaign_id', campaign_id],
            ['group_by', selectedTimeWindowOption.code],
        ]);
        axios.get(
            process.env.REACT_APP_API_HOST + '/stats/screen_time/',
            { params }
        ).then(
            (response) => {
                setScreenTimeData(response.data);
            }
        )
    }
    useEffect(
        () => {
            getScreenTime();
        },
        [selectedTimeWindowOption],
    )

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                    Screen Time
                </div>
                <Dropdown
                    value={selectedTimeWindowOption}
                    onChange={(e) => setSelectedTimeWindowOption(e.value)}
                    options={timeWindowOptions}
                    optionLabel="name"
                    placeholder="time window"
                    style={{
                        marginLeft: 'auto',
                    }}
                />
            </div>
            <BasicChart
                title='Screen Time (in seconds)'
                ox_values={screenTimeData.ox}
                oy_values={screenTimeData.oy}
            />
        </div>
    )
}

export default ChartScreenTime;